import _ from "lodash";
import axios from "src/utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tickets: [],
  details: null
};

const slice = createSlice({
  name: "tickets",
  initialState,
  reducers: {
    getAllTickets(state, action) {
      const tickets = action.payload;

      state.tickets = tickets ?? [];
    },
    getTicketDetails(state, action) {
      const details = action.payload;

      state.details = details;
    },
    addNewComment(state, action) {
      const details = action.payload;

      state.details = details;
    },
    createNewTicket(state, action) {
      const details = action.payload;

      state.details = details;
    },
    closeTicket(state, action) {
      const details = action.payload;

      state.details = details;
    },
    deleteTicketAttachment(state, action) {
      const details = action.payload;

      state.details = details;
    }
  }
});

export const reducer = slice.reducer;

export const getAllTickets = (closed) => async dispatch => {
  const response = await axios.get("/api/tickets/all?closed="+ closed);

  dispatch(slice.actions.getAllTickets(response.data));
};

export const getTicketDetails = (ticketId) => async dispatch => {
  const response = await axios.get("/api/tickets/details?ticketId="+ ticketId);

  dispatch(slice.actions.getTicketDetails(response.data));
};

export const addNewComment = (data) => async dispatch => {
  const response = await axios.post("/api/tickets/comment", data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

  dispatch(slice.actions.addNewComment(response.data));
};

export const createNewTicket = data => async dispatch => {
  const response = await axios.post("/api/tickets/new", data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

  dispatch(slice.actions.createNewTicket(response.data));
};

export const closeTicket = (ticketId, comments) => async dispatch => {
  const data = {
    ticketId,
    comments
  }

  const response = await axios.post("/api/tickets/close", data);

  dispatch(slice.actions.closeTicket(response.data));
};

export const deleteTicketAttachment = (ticketId, attachmentId) => async dispatch => {
  const response = await axios.delete(`/api/tickets/attachment?ticketId=${ticketId}&attachmentId=${attachmentId}`);

  dispatch(slice.actions.deleteTicketAttachment(response.data));
};

export default slice;
